module.exports = __webpack_public_path__ + "assets/img/waiting.1d2761e9.svg";